// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../../shared/authentication/AxiosInterceptor'
import { imageCompressor } from '../../shared/components/imageCompressor/imageCompressor'
import { ProductDataModel } from '../models/ProductData'

// ** Axios Imports

//master product
export const getProduct = createAsyncThunk('products/getProduct', async (id) => {
    const response = await axiosInstance.get(`product/${id}`)
    return response.data
})

export const addItemInBulk = createAsyncThunk('products/addItemInBulk', async (data) => {

    const response = await axiosInstance.post(`store-product/v2/bulk-upload/${data.storeId}`, data.formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    const res = response.data
    if (typeof res === 'string') return res.replace(/\s+/g, '')
    if (Array.isArray(res?.data?.errors)) return res.data.errors.join('').replace(/\s+/g, '')
    return ''
})

// POST/food-item/bulk-upload/{storeId}
export const addItemInBulkFood = createAsyncThunk('food/addItemInBulkFood', async (data) => {

    const response = await axiosInstance.post(`food-item/bulk-upload/${data.storeId}`, data.formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    const res = response.data
    const modifiedErrorMessage = res.replaceAll("\\s+", "")
    return modifiedErrorMessage
})

export const addItemInBulkAdmin = createAsyncThunk('products/addItemInBulkAdmin', async (data) => {

    const response = await axiosInstance.post(`product/bulk-upload`, data.formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    const res = response.data
    const modifiedErrorMessage = res.replaceAll("\\s+", "")
    return modifiedErrorMessage
})


export const getProductByBarcode = createAsyncThunk('products/getProductByBarcode', async (data) => {
    const response = await axiosInstance.get(`product/barcode/${data.barcode}/store/${data.id}`)
    return response.data
})


// export const getProductBarcodes = createAsyncThunk('products/getProductBarcodes', async () => {
//     const response = await axiosInstance.get('product/barcode')
//     return response.data
// })

export const getProductBarcodes = createAsyncThunk('product/getProductBarcodes', async (number) => {
    const response = await axiosInstance.get(`/product/barcode?searchTerm=${number}`)
    return response.data
})

// export const getProductList = createAsyncThunk('products/getProductList', async () => {
//     const response = await axiosInstance.get('product')
//     return response.data
// })

export const getProductCount = createAsyncThunk('products/getProductCount', async (id) => {
    const response = await axiosInstance.get(`product/count`)
    return response.data
})

export const getProductImage = createAsyncThunk('products/getProductImage', async (filename) => {
    const response = await axiosInstance.get(`getProductImage/${filename}`)
    return response.data
})

export const getProductByPage = createAsyncThunk('products/getProductByPage', async (data) => {
    const { currentPage, perPage, searchValue } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)

    const response = await axiosInstance.post('product/page', body)
    return response.data
})

export const getProductsByStatus = createAsyncThunk('products/getProductsByStatus', async (data) => {
    const { currentPage, perPage, searchValue, productStatus } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("status", productStatus)

    const response = await axiosInstance.post('product/page/status', body)
    return response.data
})

export const getProductsByCategory = createAsyncThunk('products/getProductsByCategory', async (data) => {
    const { currentPage, perPage, searchValue, id } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("categoryId", id)

    const response = await axiosInstance.post('product/page/category', body)
    return response.data
})

export const addProduct = createAsyncThunk('products/addProduct', async (data) => {
    const response = await axiosInstance.post('product', data)
    return response.data
})


export const addToCategory = createAsyncThunk('products/addToCategory', async (data) => {
    const response = await axiosInstance.post('product/add/category', data)
    return response.data
})
export const removeMultiProduct = createAsyncThunk('products/removeMutliProduct', async (data) => {
    const response = await axiosInstance.post('product/delete', data)
    return response.data
})

// V2: Delete products - POST /admin-product/v2/delete
export const deleteAdminProductsV2 = createAsyncThunk('products/deleteAdminProductsV2', async (productIds) => {
    // Ensure productIds is an array and limit to 500 as per API spec
    const ids = Array.isArray(productIds) ? productIds.slice(0, 500) : [productIds];
    const response = await axiosInstance.post('admin-product/v2/delete', ids)
    return response.data
})

export const deleteProduct = createAsyncThunk('products/deleteProduct', async (id) => {
    const response = await axiosInstance.delete(`product/${id}`)
    return response.data
})

export const uploadBulkProduct = createAsyncThunk('products/uploadBulkProduct', async (data) => {
    const formData = new FormData()
    formData.append('file', data)
    const response = await axiosInstance.post('product/bulk-upload', formData)
    return response.data
})
export const uploadProductImage = createAsyncThunk('products/uploadProductImage', async (data) => {
    let newImage = data
    if (data.size > 1000000) newImage = await imageCompressor(data)

    const formData = new FormData()
    formData.append('file', newImage)
    const response = await axiosInstance.post('upload-file', formData)
    return response.data
})


export const applyProductAction = createAsyncThunk('products/applyProductAction', async (data) => {
    const { action, id } = data

    let body = new FormData()
    body.append("action", action)

    const response = await axiosInstance.post(`product/action/${id}`, body)
    return response.data
})
export const setMultiProductByStatus = createAsyncThunk('products/setMultiProductByStatus', async (data) => {
    const response = await axiosInstance.post(`product/action-products`, data)
    return response.data
})
export const updateProducts = createAsyncThunk('products/updateProducts', async (data) => {

    const response = await axiosInstance.post(`product/update`, data)
    return response.data
})

export const updateProductPrice = createAsyncThunk('products/updateProductPrice', async (data) => {
    const { productId, price } = data

    let body = new FormData()
    body.append("price", price)

    const response = await axiosInstance.put(`product/price/${productId}`, body)
    return response.data
})

export const updateProductStatus = createAsyncThunk('products/updateProductStatus', async (data) => {
    const { productId, productStatus } = data

    let body = new FormData()
    body.append("status", productStatus)

    const response = await axiosInstance.put(`product/status/${productId}`, body)
    return response.data
})

export const getProductCategories = createAsyncThunk('products/getProductCategories', async (filename) => {
    const response = await axiosInstance.get(`admin-product/v2/category`)
    return response.data
})

// V2: Get admin product by ID - GET /admin-product/v2/{id}/product
export const getAdminProductByIdV2 = createAsyncThunk('products/getAdminProductByIdV2', async (id) => {
    const response = await axiosInstance.get(`admin-product/v2/${id}/product`)
    const res = response.data
    const raw = res?.data ?? res
    return mapAdminProductV2ToDetail(raw)
})

// V2: Add or update admin product - POST /admin-product/v2/add-update
export const addOrUpdateAdminProductV2 = createAsyncThunk('products/addOrUpdateAdminProductV2', async (data) => {
    const response = await axiosInstance.post('admin-product/v2/add-update', data)
    const res = response.data
    return res?.data ?? res
})

export const existBarcode = createAsyncThunk('products/existBarcode', async (barcode) => {
    const response = await axiosInstance.get(`product/barcode/exist/${barcode}`)
    return response.data
})

//food items
export const getFoodItem = createAsyncThunk('products/getFoodItem', async (id) => {
    const response = await axiosInstance.get(`food-item/${id}`)
    return response.data
})

export const getAIFoodItem = createAsyncThunk('products/getAIFoodItem', async (data) => {
    const { id, storeId } = data
    const response = await axiosInstance.get(`v1/ai/inventory/food/${id}?storeId=${storeId}`)
    // Handle response structure: {"data":{},"message":"SUCCESS","status":200}
    if (response.data && response.data.data) {
        return response.data.data
    }
    return response.data
})

/** GET /v1/ai/inventory/retail/{id}?storeId= — AI retail pre-inventory; may return stringified JSON for sizes/categories. */
export const getAIRetailInventoryById = createAsyncThunk(
    'products/getAIRetailInventoryById',
    async ({ id, storeId }) => {
        const response = await axiosInstance.get(
            `v1/ai/inventory/retail/${id}?storeId=${storeId}`
        )
        const raw = response.data?.data ?? response.data
        if (!raw || typeof raw !== 'object') return raw

        const parseMaybeJson = (v) => {
            if (v === null) return v
            if (typeof v === 'string') {
                try {
                    return JSON.parse(v)
                } catch {
                    return v
                }
            }
            return v
        }
        const productSizes = parseMaybeJson(raw.productSizes)
        const categories = parseMaybeJson(raw.categories)
        const out = { ...raw, barcode: raw.barcode ?? "NO BARCODE" }
        if (Array.isArray(productSizes)) out.productSizes = productSizes
        if (Array.isArray(categories)) out.categories = categories
        if (
            (out.price === null || out.price === '' || out.price === undefined) &&
            Array.isArray(out.productSizes) &&
            out.productSizes[0]
        ) {
            const s0 = out.productSizes[0]
            out.price = Number(s0.price ?? s0.sellingPrice ?? 0) || out.price
        }
        return out
    }
)
export const getFoodItemsByPage = createAsyncThunk('products/getFoodItemsByPage', async (data) => {
    const { currentPage, perPage, searchValue, id } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("storeId", id)

    const response = await axiosInstance.post('food-item/page', body)
    return response.data
})

export const getFoodItemsByStatus = createAsyncThunk('products/getFoodItemsByStatus', async (data) => {
    const { currentPage, perPage, searchValue, foodItemStatus, id } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("status", foodItemStatus)
    body.append("storeId", id)

    const response = await axiosInstance.post('food-item/page/status', body)
    return response.data
})
export const getFoodItemsByCategory = createAsyncThunk('products/getFoodItemsByCategory', async (data) => {
    const { currentPage, perPage, searchValue, id, categoryId } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("storeId", id)
    body.append("categoryId", categoryId)

    const response = await axiosInstance.post('food-item/page/category', body)
    return response.data
})

export const getFoodCategories = createAsyncThunk('products/getFoodCategories', async (storeId) => {
    const response = await axiosInstance.get(`v2/food-item/categories/${storeId}`)
    return response.data
})

// V2 Food Item APIs
export const createOrUpdateFoodItem = createAsyncThunk('products/createOrUpdateFoodItem', async (data) => {
    const { storeId, foodItemData } = data
    // surfaceErrors: without it a rejected save (e.g. a PetPooja store blocking manual adds) resolves to
    // undefined and the user sees "Cannot read properties of undefined" instead of the backend's reason.
    try {
        const response = await axiosInstance.post(`v2/food-item/${storeId}`, foodItemData, { surfaceErrors: true })
        return response.data
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Could not save the item. Please check your connection and try again.")
    }
})

export const getFoodItemV2 = createAsyncThunk('products/getFoodItemV2', async (id) => {
    const response = await axiosInstance.get(`v2/food-item/${id}`)
    return response.data
})

export const getFoodItemsWithPagination = createAsyncThunk('products/getFoodItemsWithPagination', async (params) => {
    const { storeId, categoryId, search = '', active, page = 0, size = 20, sort = 'id', direction = 'desc' } = params
    let url = `v2/food-item?storeId=${storeId}&page=${page}&size=${size}&sort=${sort}&direction=${direction}`
    if (categoryId) url += `&categoryId=${categoryId}`
    if (search) url += `&search=${encodeURIComponent(search)}`
    if (active !== undefined) url += `&active=${active}`
    const response = await axiosInstance.get(url)
    return response.data
})

export const deleteFoodItems = createAsyncThunk('products/deleteFoodItems', async (ids) => {
    const response = await axiosInstance.delete('v2/food-item', { data: ids })
    return response.data
})

export const updateFoodItemStatusV2 = createAsyncThunk('products/updateFoodItemStatusV2', async (data) => {
    const { id, status } = data
    const response = await axiosInstance.put(`v2/food-item/status/${id}?status=${status}`)
    return response.data
})

export const copyFoodItemsBetweenStores = createAsyncThunk('products/copyFoodItemsBetweenStores', async (data) => {
    const { fromStoreId, toStoreId } = data
    const response = await axiosInstance.post(`v2/food-item/copy-foods?fromStoreId=${fromStoreId}&toStoreId=${toStoreId}`)
    return response.data
})

export const updateFoodItemSequences = createAsyncThunk('products/updateFoodItemSequences', async (data) => {
    const response = await axiosInstance.put('v2/food-item/update-sequences', data)
    return response.data
})

export const updateCategorySequences = createAsyncThunk('products/updateCategorySequences', async (data) => {
    const response = await axiosInstance.put('v2/food-item/category-sequences', data)
    return response.data
})

export const updateFoodItemStock = createAsyncThunk('products/updateFoodItemStock', async (data) => {
    const { storeId, foodItemId, stockQuantity } = data
    const response = await axiosInstance.put(`v2/food-item/stock/${storeId}`, { foodItemId, stockQuantity })
    return response.data
})

export const updateFoodItemPrice = createAsyncThunk('products/updateFoodItemPrice', async (data) => {
    const { storeId, foodItemId, sellingPrice, crossPrice } = data
    const requestBody = { foodItemId, sellingPrice }
    if (crossPrice !== undefined) requestBody.crossPrice = crossPrice
    const response = await axiosInstance.put(`v2/food-item/price/${storeId}`, requestBody)
    return response.data
})

export const updateFoodSequence = createAsyncThunk('update/foodSequence', async (data) => {
    const { id, reqData } = data
    const response = await axiosInstance.put(`food-item/update-sequence?storeId=${id}`, reqData)
    return response.data
})

export const updateRetailSequence = createAsyncThunk('update/retailSequence', async (data) => {
    const { id, reqData } = data
    const response = await axiosInstance.put(`store-product/update-sequence?storeId=${id}`, reqData)
    return response.data
})

// V2: Update category display order - PUT store-product/v2/category-display-order?storeId={storeId}
export const updateCategoryDisplayOrderV2 = createAsyncThunk(
    'products/updateCategoryDisplayOrderV2',
    async ({ storeId, sequences }) => {
        const body = { sequences }
        const response = await axiosInstance.put(
            `store-product/v2/category-display-order?storeId=${storeId}`,
            body,
            { headers: { 'Content-Type': 'application/json' } }
        )
        return response.data
    }
)

export const handleDeleteMultiInventory = createAsyncThunk('products/getFoodCategoryNames', async (data) => {

    const response = await axiosInstance.post(`/store-product/delete`, data)
    return response.data
})

// V2: Delete store products - POST store-product/v2/delete?storeId={storeId}, body: product ID array
export const deleteStoreProductsV2 = createAsyncThunk(
    'products/deleteStoreProductsV2',
    async ({ storeId, productIds }) => {
        const response = await axiosInstance.post(
            `store-product/v2/delete?storeId=${storeId}`,
            productIds,
            { headers: { 'Content-Type': 'application/json' } }
        )
        return response.data
    }
)
export const handleDeleteMultiFood = createAsyncThunk('products/getFoodCategoryNames', async (data) => {

    const response = await axiosInstance.post(`/food-item/delete`, data)
    return response.data
})
export const addFoodItem = createAsyncThunk('products/addFoodItem', async (itemData) => {
    const { data, id } = itemData
    const response = await axiosInstance.post(`food-item/${id}`, data)
    return response.data
})

export const addNewFoodCategory = createAsyncThunk('products/addNewFoodCategory', async (itemData) => {
    const { id, name } = itemData

    let body = new FormData()
    body.append("storeId", id)
    body.append("categoryName", name)
    const response = await axiosInstance.post(`food-item/add/category`, body)
    return response.data
})

export const addToFoodCategory = createAsyncThunk('products/addToFoodCategory', async (data) => {
    const response = await axiosInstance.post('v2/food-item/add-to/category', data)
    return response.data
})

export const saveFoodCategory = createAsyncThunk('products/saveFoodCategory', async (data) => {
    const { id, name } = data

    let body = new FormData()
    body.append("storeId", id)
    body.append("name", name)
    const response = await axiosInstance.post('food-item/save/category', body)
    return response.data
})

export const deleteFoodCategory = createAsyncThunk('products/deleteFoodCategory', async (name) => {
    const response = await axiosInstance.delete(`food-item/delete/category/${name}`)
    return response.data
})

export const updateFoodItems = createAsyncThunk('products/updateFoodItems', async (data) => {

    const response = await axiosInstance.post(`food-item/update`, data)
    return response.data
})

export const updateFoodItemStatus = createAsyncThunk('products/updateFoodItemStatus', async (data) => {
    const { productId, productStatus } = data
    let body = new FormData()
    body.append("status", productStatus)

    const response = await axiosInstance.put(`food-item/status/${productId}`, body)
    return response.data
})
//store products
export const getPendingProductCount = createAsyncThunk('products/getPendingProductCount', async (id) => {
    const response = await axiosInstance.get(`store-product/pending/count`)
    return response.data
})
export const getStoreProduct = createAsyncThunk('products/getStoreProduct', async (id) => {
    const response = await axiosInstance.get(`store-product/${id}`)
    return response.data
})

const mapV2ImageEntry = (img) => {
    const name = typeof img === 'string' ? img.trim() : String(img?.url || img?.name || img || '').trim()
    return name ? { name, src: name } : null
}

/** Same image list on every size → one gallery row ("all sizes"). Different per size → [] so ProductAdd expands each. */
const legacyProductImagesFromV2Sizes = (sizes, fallbackProductImages) => {
    if (!Array.isArray(sizes) || sizes.length === 0) {
        return Array.isArray(fallbackProductImages) ? fallbackProductImages : []
    }
    const keyOf = (imgs) => {
        const arr = Array.isArray(imgs) ? imgs : imgs !== null && imgs !== '' ? [imgs] : []
        return JSON.stringify(
            arr
                .map((i) => (typeof i === 'string' ? i.trim() : String(i?.url || i?.name || i || '').trim()))
                .filter(Boolean)
        )
    }
    const k0 = keyOf(sizes[0]?.images)
    const hasAny = sizes.some((s) => keyOf(s.images) !== '[]')
    const allSameAsFirst = sizes.every((s) => keyOf(s.images) === k0)
    if (hasAny && sizes.length > 1 && !allSameAsFirst) {
        return []
    }
    const raw0 = sizes[0]?.images
    const parts0 = Array.isArray(raw0) ? raw0 : raw0 !== null && raw0 !== '' ? [raw0] : []
    const fromFirst = parts0.map(mapV2ImageEntry).filter(Boolean)
    if (fromFirst.length) return fromFirst
    return Array.isArray(fallbackProductImages) ? fallbackProductImages : []
}

// Map v2 Admin Product response to legacy shape for ProductAdd/ProductDetail (productSizes, productImages)
const mapAdminProductV2ToDetail = (data) => {
    if (!data) return data
    const sizes = data.sizes || []
    const productSizes = sizes.map((s) => ({
        ...s,
        unitValue: s.unitValue ?? s.weight ?? s.size,
        newUnit: s.newUnit ?? s.unit ?? '',
        quantity: s.quantity ?? 0,
        sizeStock: s.quantity ?? 0,
        price: s.price ?? s.basePrice ?? s.sellingPrice ?? 0,
        crossPrice: s.crossPrice ?? 0,
        packagingCharge: s.packagingCharge ?? 0,
    }))
    const productImages = legacyProductImagesFromV2Sizes(sizes, data.productImages)
    // Map categoryName/categoryId to categories array
    const categories = data.categories || (data.categoryName ? [{ id: data.categoryId, name: data.categoryName }] : [])
    const firstPrice = sizes[0]?.price ?? sizes[0]?.basePrice ?? sizes[0]?.sellingPrice ?? data.price ?? 0
    return {
        ...data,
        productSizes,
        productImages,
        categories,
        price: firstPrice,
    }
}

// Map v2 StoreProductDetailResponse to legacy shape for ProductAdd/ProductDetail (productSizes, productImages)
const mapStoreProductV2ToDetail = (data) => {
    if (!data) return data
    const sizes = data.sizes || []
    const productSizes = sizes.map((s) => ({
        ...s,
        unitValue: s.unitValue ?? s.size,
        newUnit: s.newUnit ?? s.unit,
        quantity: s.quantity,
        sizeStock: s.quantity,
        price: s.price ?? s.basePrice ?? s.sellingPrice,
        packagingCharge: s.packagingCharge ?? 0,
    }))
    const productImages = legacyProductImagesFromV2Sizes(sizes, data.productImages)
    const categories = data.categories || (data.categoryName ? [{ id: data.categoryId, name: data.categoryName }] : [])
    const firstPrice = sizes[0]?.price ?? sizes[0]?.basePrice ?? sizes[0]?.sellingPrice ?? data.price
    return {
        ...data,
        productSizes,
        productImages,
        categories,
        price: firstPrice,
    }
}

// V2: Get store product by ID (edit-time detail) - GET store-product/v2/{id}/storeProduct
export const getStoreProductByIdV2 = createAsyncThunk('products/getStoreProductByIdV2', async (id) => {
    const response = await axiosInstance.get(`store-product/v2/${id}/storeProduct`)
    const res = response.data
    const raw = res?.data ?? res
    return mapStoreProductV2ToDetail(raw)
})

export const getStoreProductCategories = createAsyncThunk('products/getStoreProductCategories', async (id) => {
    const response = await axiosInstance.get(`store-product/category/${id}`)
    return response.data
})

// GET store/item-tags?type={type} - item tags for dropdown (e.g. type=retail)
export const getStoreItemTags = createAsyncThunk('products/getStoreItemTags', async (type = 'retail') => {
    const response = await axiosInstance.get('store/item-tags', { params: { type } })
    const res = response.data
    const raw = res?.data ?? res
    const list = Array.isArray(raw) ? raw : (raw && typeof raw === 'object' ? Object.values(raw) : [])
    return list.map((item) => {
        if (typeof item === 'string') return { value: item, label: item }
        const name = item.name ?? item.label ?? String(item.id ?? item)
        return { value: name, label: name }
    })
})

// V2: Get store categories for dropdown/listing - GET store-product/v2/{storeId}/categories
export const getStoreCategoriesV2 = createAsyncThunk('products/getStoreCategoriesV2', async (storeId) => {
    const response = await axiosInstance.get(`store-product/v2/${storeId}/categories`)
    const res = response.data
    const list = res?.data ?? res ?? []
    return Array.isArray(list)
        ? list.map((c) => ({
            categoryId: c.categoryId,
            categoryName: c.categoryName,
            displayOrder: c.displayOrder,
            productCount: c.productCount,
            id: c.categoryId,
            name: c.categoryName,
            label: c.categoryName,
            value: c.categoryId,
        }))
        : []
})
export const getPendingStoreProducts = createAsyncThunk('products/getPendingStoreProducts', async (data) => {
    const { currentPage, perPage, searchValue, productStatus } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("status", productStatus)

    const response = await axiosInstance.post('store-product/page/status', body)
    return response.data
})
export const getStoreProductsByCategory = createAsyncThunk('products/getStoreProductsByCategory', async (data) => {
    const { currentPage, perPage, searchValue, store, category } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("storeId", store)
    body.append("categoryId", category)

    const response = await axiosInstance.post('store-product/page/category', body)
    return response.data
})
export const getStoreProductsByStatus = createAsyncThunk('products/getStoreProductsByStatus', async (data) => {
    const { currentPage, perPage, searchValue, id, productStatus } = data

    let body = new FormData()
    body.append("page", currentPage)
    body.append("perpage", perPage)
    body.append("generalSearch", searchValue)
    body.append("storeId", id)
    body.append("status", productStatus)

    const response = await axiosInstance.post('store-product/page/store/status', body)
    return response.data
})

// Map v2 StoreProductDetailResponse item to legacy list row shape (productSizes, productImages)
const mapStoreProductV2ToListRow = (item) => {
    if (!item) return item
    const sizes = item.sizes || []
    const productImages = (sizes[0]?.images?.length) ? (sizes[0].images.map(img => (typeof img === 'string' ? { name: img } : { name: img?.url || img }))) : (item.productImages || [])
    return {
        ...item,
        productSizes: sizes.map(s => ({
            ...s,
            unitValue: s.unitValue ?? s.size,
            newUnit: s.newUnit ?? s.unit,
            sizeStock: s.quantity,
            price: s.price ?? s.basePrice ?? s.sellingPrice,
        })),
        productImages: productImages.length ? productImages : (item.images ? (Array.isArray(item.images) ? item.images.map(i => ({ name: i })) : [{ name: item.images }]) : []),
        categories: item.categories || (item.categoryName ? [{ name: item.categoryName }] : []),
        price: (sizes[0]?.price ?? sizes[0]?.basePrice ?? sizes[0]?.sellingPrice ?? item.price) ?? 0,
    }
}

// V2: Update product sequences within a category (retail drag-drop) — PUT store-product/v2/update-sequences
export const updateStoreProductSequencesV2 = createAsyncThunk(
    'products/updateStoreProductSequencesV2',
    async ({ storeId, categoryId, sequences }) => {
        const body = {
            storeId: Number(storeId),
            categoryId: Number(categoryId),
            sequences,
        }
        const response = await axiosInstance.put('store-product/v2/update-sequences', body, {
            headers: { 'Content-Type': 'application/json' },
        })
        return response.data
    }
)

// V2: Get store product list - GET store-product/v2/list
export const getStoreProductListV2 = createAsyncThunk('products/getStoreProductListV2', async (data) => {
    const { storeId, page = 0, size = 10, search = '', categoryId, 
        status = 'approved', sort = "id", direction = "desc"
     } = data
    const params = new URLSearchParams()
    if (storeId !== undefined && storeId !== null && storeId !== '') params.append('storeId', storeId)
    params.append('page', String(page))
    params.append('size', String(Math.min(size, 100)))
    if (search) params.append('search', search)
    if (status) params.append('status', status)
    if (categoryId !== undefined && categoryId !== '' && categoryId !== null) params.append('categoryId', categoryId)
    if(!categoryId){
        params.append('sort', 'id')
        params.append('direction', direction)
    }
    // if (sort !== undefined && sort !== null && sort !== '') params.append('sort', sort)
    // if (direction !== undefined && direction !== null && direction !== '') params.append('direction', direction)
    const response = await axiosInstance.get(`store-product/v2/list?${params.toString()}`)
    const res = response.data
    const payload = res?.data ?? res
    const rawData = payload?.data ?? []
    const meta = payload?.meta ?? {}
    const pageNum = meta.page ?? page
    const perpage = meta.perpage ?? size
    const hasNext = meta.hasNext ?? false
    const rows = Array.isArray(rawData) ? rawData.map(mapStoreProductV2ToListRow) : []
    const totalPages = meta.totalPages ?? (hasNext ? pageNum + 2 : pageNum + 1)
    const total = meta.total ?? (pageNum * perpage + rows.length)
    return {
        data: rows,
        meta: {
            total,
            pages: totalPages,
            page: pageNum + 1,
            hasNext,
        },
    }
})

export const addStoreProduct = createAsyncThunk('products/addStoreProduct', async (data) => {
    const response = await axiosInstance.post(`store-product`, data)
    return response.data
})

// V2: Add or update store product - POST store-product/v2/add-update
export const storeProductAddUpdateV2 = createAsyncThunk(
    'products/storeProductAddUpdateV2',
    async (body) => {
        const response = await axiosInstance.post('store-product/v2/add-update', body)
        return response.data
    }
)

// V2: Update approval status - PUT store-product/v2/approval-status
// status: query parameter (approved/declined)
// body: array of product IDs
export const updateProductApprovalStatusV2 = createAsyncThunk(
    'products/updateProductApprovalStatusV2',
    async (data) => {
        const { status, productIds } = data
        const params = new URLSearchParams()
        params.append('status', status)
        const response = await axiosInstance.put(`store-product/v2/approval-status?${params.toString()}`, productIds)
        return response.data
    }
)
export const getGTIN = createAsyncThunk('product/getGTIN', async (data) => {
    const response = await axiosInstance.get(`product/getGTIN?GTIN=${data}`)
    return response.data
})

export const addStoreProductFromList = createAsyncThunk('products/addStoreProduct', async (data) => {
    const { storeId, storeProduct } = data
    const response = await axiosInstance.post(`store-product/add?storeId=${storeId}`, storeProduct)
    return response.data
})

export const updateStoreProducts = createAsyncThunk('products/updateStoreProducts', async (data) => {

    const response = await axiosInstance.post(`store-product/update`, data)
    return response.data
})

export const updateStoreProductPrice = createAsyncThunk('products/updateProductPrice', async (data) => {
    const { productId, price } = data

    let body = new FormData()
    body.append("price", price)

    const response = await axiosInstance.put(`store-product/price/${productId}`, body)
    return response.data
})

export const updateStoreProductStatus = createAsyncThunk('products/updateProductStatus', async (data) => {
    const { productId, productStatus } = data

    let body = new FormData()
    body.append("status", productStatus)

    const response = await axiosInstance.put(`store-product/status/${productId}`, body)
    return response.data
})

// V2: Update product visibility (online/offline) - PUT store-product/v2/visibility
export const updateStoreProductVisibilityV2 = createAsyncThunk(
    'products/updateStoreProductVisibilityV2',
    async ({ storeId, active, productIds }) => {
        const params = new URLSearchParams({ storeId: String(storeId), active: String(active) })
        const response = await axiosInstance.put(
            `store-product/v2/visibility?${params.toString()}`,
            productIds,
            { headers: { 'Content-Type': 'application/json' } }
        )
        return response.data
    }
)

// POST store-product/v2/assign-category?storeId={storeId}, body: { categoryId, productIds }
export const addCategoryStore = createAsyncThunk('products/addToCategoryStore', async (data) => {
    const { storeId, categoryId, storeProductIds } = data
    const productIds = storeProductIds ?? data.productIds ?? []
    const response = await axiosInstance.post(
        `store-product/v2/assign-category?storeId=${storeId}`,
        { categoryId, productIds }
    )
    return response.data
})


export const uploadBulkStoreProduct = createAsyncThunk('products/uploadBulkStoreProduct', async (data) => {
    const { id, fileData } = data

    const formData = new FormData()

    formData.append('file', fileData)
    const response = await axiosInstance.post(`store-product/bulk-upload/${id}`, formData)
    return response.data
})

// Inventory list - GET admin-product/v2/list (used by InventoryList component)
export const getInventoryByPage = createAsyncThunk('products/getInventoryByPage', async (data) => {
    const { currentPage = 0, perPage = 10, searchValue, categoryId, status, storeId } = data

    const params = new URLSearchParams()
    params.append('page', String(currentPage))
    params.append('size', String(Math.min(perPage, 100)))
    if (searchValue) params.append('search', searchValue)
    if (categoryId !== undefined && categoryId !== '' && categoryId !== null) params.append('categoryId', categoryId)
    if (status) params.append('status', status)
    if (storeId !== undefined && storeId !== null && storeId !== '') params.append('storeId', String(storeId))

    const response = await axiosInstance.get(`admin-product/v2/list?${params.toString()}`)
    const res = response.data
    // API returns { data: [], meta: { page, total, perpage, totalPages/totalpages, hasNext } } at top level
    const rawData = Array.isArray(res?.data) ? res.data : (res?.data?.data ?? [])
    const meta = res?.meta ?? res?.data?.meta ?? {}
    const perpage = meta.perpage ?? perPage
    const total = meta.total ?? (currentPage * perpage + (Array.isArray(rawData) ? rawData.length : 0))
    const totalPages = meta.totalPages ?? meta.totalpages ?? Math.max(1, Math.ceil(total / perpage))
    const displayPage = currentPage + 1
    return {
        data: rawData,
        meta: {
            total,
            pages: totalPages,
            page: displayPage,
            perpage,
            hasNext: meta.hasNext ?? false,
        },
    }
})

// Admin product list v2 - GET /admin-product/v2/list
export const getAdminProductListV2 = createAsyncThunk('products/getAdminProductListV2', async (data) => {
    const { page = 0, size = 10, search = '', categoryId, status } = data

    const params = new URLSearchParams()
    params.append('page', String(page))
    params.append('size', String(Math.min(size, 100)))
    if (search) params.append('search', search)
    if (categoryId !== undefined && categoryId !== '' && categoryId !== null) params.append('categoryId', categoryId)
    if (status) params.append('status', status)

    const response = await axiosInstance.get(`admin-product/v2/list?${params.toString()}`)
    const res = response.data
    const payload = res?.data ?? res
    const rawData = payload?.data ?? []
    const meta = payload?.meta ?? {}
    return {
        data: rawData,
        meta,
    }
})


const initialState = {
    products: [ProductDataModel]
}

export const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder

            .addCase(getProductByPage.fulfilled, (state, action) => {
                Object.assign(state.products, action.payload.data)

            })

    }
})

export const getFoodItemsByPageAI = createAsyncThunk('products/getFoodItemsByPageAI', async (data) => {
    const { currentPage, perPage, id , searchValue, type} = data

    const response = await axiosInstance.get(`v1/ai/inventory/pre?page=${currentPage}&size=${perPage}&storeId=${id}&search=${searchValue}&type=${type}`)
    return response.data
})

export const getFoodItemsByPageAIJob = createAsyncThunk('products/getFoodItemsByPageAISearch', async (data) => {
    const { id } = data
    const response = await axiosInstance.get(`v1/ai/inventory/jobs?page=0&size=${1}&storeId=${id}`)
    return response.data
})

export const approveDeclineFoodItemsAI = createAsyncThunk('products/approveDeclineFoodItemsAI', async (data) => {
    const { type, action, ids } = data
    const response = await axiosInstance.post('v1/ai/inventory/approval', {
        type,
        action,
        ids
    })
    return response.data
})

export const updatePreInventory = createAsyncThunk('products/updatePreInventory', async (data) => {
    const { type, id, storeId, fields } = data
    const response = await axiosInstance.put('v1/ai/inventory/pre/edit', {
        type,
        id,
        storeId,
        fields
    })
    return response.data
})

export const getAllFoodCategories = createAsyncThunk('category/categoryType', async (storeId) => {
    const response = await axiosInstance.get(`category/categoryType?categoryType=food`)
    return response.data
})
export default productsSlice.reducer

